let gLocatorMap;
let gLocatorMapMarkers = [];
let gAutocomplete;
let gMarkerClusterer;
const defaultMapCenter = { lat: 52, lng: 5 };
const defaultMapZoom = 7.5;
const geoSearchInputId = 'js-post-search-location-input';
const geoSearchAutocompletedInputSelector = '#js-post-search-location-autocompleted-input';
const geoLoadMoreSelector = '#js-post-location-load-more';
const geoResultsFoundSelector = '.t-post-geolocation-search__result-found';
const geoSearchFiltersSelector = '.js-toggle-post-geolocation-filter';
const geoSearchFilterItem = '.js-post-geolocation-filter-item';
const geoSearchResetFilters = '.js-reset-term-filters';
const geoSearchSelectedFilters = '.js-selected-filter-item';
const postIdSelector = '.js-post-id';

function initMapsLoaders() {
  const postLocatorElement = document.getElementById('js-post-locator-map');

  if (postLocatorElement === null) {
    return;
  }
  // Short namespaces can be used.
  gLocatorMap = new google.maps.Map(postLocatorElement, {
    center: defaultMapCenter,
    zoom: defaultMapZoom,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
  });

  const establishments = $(postIdSelector).data('establishments') === 1;
  const types = ['geocode'];
  if (establishments) {
    types.push('establishment');
  }

  gAutocomplete = new google.maps.places.Autocomplete(document.getElementById(geoSearchInputId), {
    types,
    componentRestrictions: { country: 'nl' },
    fields: ['formatted_address', 'place_id', 'geometry', 'name'],
  });
  gAutocomplete.addListener('place_changed', geoPlaceChanged);

  const $geoLocationSearch = $(`#${geoSearchInputId}`);
  const $geoLocationLoadMore = $(geoLoadMoreSelector);
  const $geoSearchFilters = $(geoSearchFiltersSelector);
  const $geoSearchFilterItem = $(geoSearchFilterItem);
  const $geoResetFilters = $(geoSearchResetFilters);

  $geoLocationSearch.on('search', (evt) => {
    if ($(evt.currentTarget).val() === '') {
      clearGeoLocationSearchResults();
      removeGeoLocationMapMarkers();
      setGeoBounds();
    }
  });

  $geoLocationSearch.on('keyup', () => {
    setTimeout(() => {
      let formattedVal = '';
      const e = document.querySelector('.pac-container');
      if (e && e.hasChildNodes()) {
        const n = e.children.item(0).children.item(1).innerText;
        const o = e.children.item(0).children.item(2).innerText;
        formattedVal = `${n}, ${o}`;
      }
      updateFormattedGeoLocation(formattedVal);
    }, 200);
  });

  $geoSearchFilters.on('click', function () {
    $(this).parent().toggleClass('is-open');
  });

  $geoSearchFilterItem.on('click', function () {
    const filterValue = $(this).val();
    const filterType = $(this).data('type');

    $geoSearchFilters.parent().removeClass('is-open');

    addFilterTermToAddressBar(filterType, filterValue);

    doGeoLocationSearch(
      $(geoSearchAutocompletedInputSelector).attr('data-lat'),
      $(geoSearchAutocompletedInputSelector).attr('data-lng'),
      0,
      getSelectedFilters(),
    );
  });

  $geoLocationLoadMore.on('click', () => {
    const offset = $('.t-post-geolocation-search__search-results .c-post-geolocation-search-result-card').length;

    doGeoLocationSearch(
      $(geoSearchAutocompletedInputSelector).attr('data-lat'),
      $(geoSearchAutocompletedInputSelector).attr('data-lng'),
      offset,
      getSelectedFilters(),
    );
  });

  $geoResetFilters.on('click', (e) => {
    e.preventDefault();
    $geoSearchFilterItem.each(function () {
      if ($(this).is(':checked')) {
        removeFilterTermFromAddressBar($(this).data('type'));
        $(this).prop('checked', false);
      }
    });

    doGeoLocationSearch(
      $(geoSearchAutocompletedInputSelector).attr('data-lat'),
      $(geoSearchAutocompletedInputSelector).attr('data-lng'),
      0,
      [],
    );
  });

  initSelectedFilters();
  setGeoLocationMapMarkers();
  setGeoBounds();
}

window.initMapsLoaders = initMapsLoaders;

function initSelectedFilters() {
  $(geoSearchSelectedFilters).off();
  $(geoSearchSelectedFilters).on('click', function () {
    const filterId = $(this).data('filter');
    $(geoSearchFilterItem).each(function () {
      if (Number($(this).val()) === filterId) {
        removeFilterTermFromAddressBar($(this).data('type'));
        $(this).prop('checked', false);
      }
    });

    doGeoLocationSearch(
      $(geoSearchAutocompletedInputSelector).attr('data-lat'),
      $(geoSearchAutocompletedInputSelector).attr('data-lng'),
      0,
      getSelectedFilters(),
    );
  });
}

function clearGeoLocationSearchResults() {
  $('.js-post-location-results').html('');
  updateGeoLocationSearchResultCount(false);
  setGeoLoadMoreButtonVisibility(false);
  handleGeoLocationSearchTermUpdate('');
}

function updateGeoLocationSearchResultCount(active = true, count = 0) {
  $(geoResultsFoundSelector).attr('data-active', active ? 1 : 0);
  $('.t-post-geolocation-search__result-found .js-geolocation-result-count').html(count);
}

function setGeoLoadMoreButtonVisibility(hasNext = false) {
  $(geoLoadMoreSelector).attr('data-has-next', hasNext ? 1 : 0);
}

function updateGeoLocationSearchResults(html, offset, total, hasNext, selectedFilterHtml) {
  const $postLocationResultsElement = $('.js-post-location-results');

  if (offset > 0) {
    $postLocationResultsElement.append(html);
  } else {
    updateGeoLocationSearchResultCount(true, total);
    $postLocationResultsElement.html(html);
  }
  setGeoLoadMoreButtonVisibility(hasNext);
  $('.js-selected-filters').html(selectedFilterHtml);
}

function geoPlaceChanged() {
  const place = gAutocomplete.getPlace();
  if (place !== null && place.geometry) {
    handleGeoLocationSearchTermUpdate(
      place.formatted_address,
      place.geometry.location.lat(),
      place.geometry.location.lng(),
    );
    doGeoLocationSearch(
      place.geometry.location.lat(),
      place.geometry.location.lng(),
      0,
      getSelectedFilters(),
    );
  }
}

function updateFormattedGeoLocation(val, lat = '', lng = '') {
  $(geoSearchAutocompletedInputSelector).attr('data-lat', lat);
  $(geoSearchAutocompletedInputSelector).attr('data-lng', lng);
  $(geoSearchAutocompletedInputSelector).val(val);
}

function handleGeoLocationSearchTermUpdate(formattedLocation, lat = null, lng = null) {
  updateFormattedGeoLocation(formattedLocation, lat, lng);
  updateAddressBarWithGeoSearchTerm(formattedLocation);
  // update URL: Set searchterm
}

function updateAddressBarWithGeoSearchTerm(term) {
  // urlParams = new URLSearchParams(window.location.search);
  urlParams.delete('location');

  if (term !== '') {
    urlParams.set('location', term);
  }
  window.history.replaceState({}, '', `${location.pathname}?${urlParams}`);
}

function addFilterTermToAddressBar(filterType, termId) {
  // urlParams = new URLSearchParams(window.location.search);
  urlParams.delete(filterType);

  if (termId !== '' && filterType !== '') {
    urlParams.set(filterType, termId);
  }
  window.history.replaceState({}, '', `${location.pathname}?${urlParams}`);
}

function removeFilterTermFromAddressBar(filterType) {
  // urlParams = new URLSearchParams(window.location.search);
  urlParams.delete(filterType);
  window.history.replaceState({}, '', `${location.pathname}?${urlParams}`);
}

function doGeoLocationSearch(lat, lng, offset = 0, selectedFilters = []) {
  getPostGeoLocationSearchResults(lat, lng, offset, selectedFilters, (response) => {
    const requiredProps = ['html', 'total', 'hasNext', 'selectedFilterHtml'];
    if (requiredProps.every((x) => x in response)) {
      updateGeoLocationSearchResults(
        response.html,
        offset,
        response.total,
        response.hasNext,
        response.selectedFilterHtml,
      );
    }
    removeGeoLocationMapMarkers();
    setGeoLocationMapMarkers();
    setGeoBounds();
    initSelectedFilters();
  });
}

function getPostGeoLocationSearchResults(lat, lng, offset = 0, selectedFilters, successCallback) {
  const postId = $(postIdSelector).data('id');
  // $('.js-loading').addClass('is-loading');
  $('.js-t-post-geolocation-search-loading').addClass('is-loading');
  const ajax_url = (typeof linku_ajax_url !== 'undefined') ? linku_ajax_url : '/wp/wp-admin/admin-ajax.php';
  $.ajax({
    url: ajax_url,
    type: 'post',
    data: {
      action: 'post_geo_location_search',
      lat,
      lng,
      offset,
      selectedFilters,
      postId,
    },
    dataType: 'json',
    success: successCallback,
    error(response) {
      console.log('error', response);
      // $searchResults.removeClass('is_loading');
    },
    complete() {
      $('.js-t-post-geolocation-search-loading').removeClass('is-loading');
    },
  });
}

function removeGeoLocationMapMarkers() {
  // Clear existing marker clusterer
  if (gMarkerClusterer) {
    gMarkerClusterer.clearMarkers();
  }
  
  // Clear markers array
  gLocatorMapMarkers = [];
}

function setGeoBounds() {
  if (gLocatorMapMarkers.length === 0) {
    gLocatorMap.setCenter(defaultMapCenter);
    gLocatorMap.setZoom(defaultMapZoom);
    return;
  }

  const bounds = new google.maps.LatLngBounds();
  for (let i = 0; i < gLocatorMapMarkers.length; i += 1) {
    bounds.extend(gLocatorMapMarkers[i].getPosition());
  }
  gLocatorMap.fitBounds(bounds);
  gLocatorMap.setCenter(bounds.getCenter());
}

function setGeoLocationMapMarkers() {
  let lastOpenedInfoWindow;

  const $resultCards = $('.js-post-location-results .js-result-card');

  // Group result cards by coordinates to handle overlapping markers
  const coordinateGroups = {};
  
  // First pass: group cards by coordinates
  $resultCards.each(function (index, element) {
    this.setAttribute('data-index', index);
    const latitude = parseFloat(element.getAttribute('data-latitude'));
    const longitude = parseFloat(element.getAttribute('data-longitude'));
    const coordKey = `${latitude},${longitude}`;
    
    if (!coordinateGroups[coordKey]) {
      coordinateGroups[coordKey] = [];
    }
    coordinateGroups[coordKey].push(element);
  });

  // Second pass: create markers with offset for overlapping coordinates
  Object.keys(coordinateGroups).forEach((coordKey) => {
    const cards = coordinateGroups[coordKey];
    const [baseLat, baseLng] = coordKey.split(',').map(parseFloat);
    
    cards.forEach((element, index) => {
      // Calculate offset for overlapping markers
      let offsetLat = baseLat;
      let offsetLng = baseLng;
      
      if (cards.length > 1) {
        // Create a small offset in a circular pattern
        const angle = (index / cards.length) * 2 * Math.PI;
        const offsetDistance = 0.00001; // Small offset in degrees (much smaller than before)
        offsetLat += Math.cos(angle) * offsetDistance;
        offsetLng += Math.sin(angle) * offsetDistance;
      }
      
      const location = { lat: offsetLat, lng: offsetLng };

      const marker = new google.maps.Marker({
        position: location,
        map: null, // Don't add to map directly, let clusterer handle it
      });

      gLocatorMapMarkers.push(marker);

      marker.addListener('click', () => {
        const employerDocument = new DOMParser().parseFromString(element.outerHTML, 'text/html');
        const $content = $(employerDocument.firstChild).find('.js-result-card');
        const markerContent = $content[0];

        markerContent.classList.add('marker-modal');
        const markerid = markerContent.getAttribute('id');
        markerContent.setAttribute('id', `${markerid}-marker`);

        const infoWindow = new google.maps.InfoWindow({
          content: markerContent.outerHTML,
          maxWidth: 800,
          maxHeight: 100,
        });

        if (lastOpenedInfoWindow) {
          lastOpenedInfoWindow.close();
        }

        lastOpenedInfoWindow = infoWindow;
        infoWindow.open(gLocatorMap, marker);
        scrollIntoPostLocationMarkerView(markerid);
      });
    });
  });

  // Create or update marker clusterer
  if (gMarkerClusterer) {
    gMarkerClusterer.clearMarkers();
    gMarkerClusterer.addMarkers(gLocatorMapMarkers);
  } else {
    // Initialize marker clusterer if it doesn't exist
    gMarkerClusterer = new markerClusterer.MarkerClusterer({
      map: gLocatorMap,
      markers: gLocatorMapMarkers,
      algorithm: new markerClusterer.SuperClusterAlgorithm({
        radius: 100,
        maxZoom: 15,
      }),
    });
  }
}

function scrollIntoPostLocationMarkerView() {
  // TODO: Implement scroll functionality if needed
  // const pulse = [
  //   { outline: 'solid 0px var(--color-primary)' },
  //   { outline: 'solid 5px var(--color-primary)' },
  //   { outline: 'solid 0px var(--color-primary)' },
  // ];

  // const pulseTiming = {
  //   duration: 2000,
  //   iterations: 2,
  // };
}

function getSelectedFilters() {
  const $selectedFilters = [];
  $(geoSearchFilterItem).each(function () {
    if ($(this).is(':checked')) {
      $selectedFilters.push($(this).val());
    }
  });
  return $selectedFilters;
}

